<template>
  <form ref="resetPassword" class="change-password-form" novalidate>
    <custom-input
      id="oldPassword"
      inputType="password"
      placeholder="Введите старый пароль"
      labelText="Старый пароль"
      v-model="oldPassword"
      class="change-password-input"
      @keydown.enter.prevent="changePassword"
      :errorMessage="errors['oldPassword']"
      :inputValue="oldPassword"
      required
    />

    <custom-input
      id="newPassword"
      inputType="password"
      placeholder="Введите новый пароль"
      labelText="Новый пароль"
      v-model="newPassword"
      class="change-password-input"
      @keydown.enter.prevent="changePassword"
      :errorMessage="errors['newPassword']"
      :inputValue="newPassword"
      required
    />
    <main-text v-if="!errors['newPassword']" class="change-password-info" color="gray-2" mode="caption">
      Пароль должен содержать мин. 8 символов
    </main-text>

    <custom-input
      id="passwordRepeat"
      inputType="password"
      placeholder="Повторите новый пароль"
      labelText="Повторите пароль"
      v-model="passwordRepeat"
      class="change-password-input"
      @keydown.enter.prevent="changePassword"
      :errorMessage="errors['passwordRepeat']"
      :inputValue="passwordRepeat"
      required
    />
    <main-button
      class="change-password-button"
      @click="changePassword"
      type="button"
      :loading="loading"
      color="secondary-fill"
      >Изменить</main-button
    >
  </form>
</template>

<script>
import Input from "./ui/Input.vue";
import MainButton from "./ui/MainButton.vue";
import Text from "./ui/Text.vue";
export default {
  components: { "custom-input": Input, "main-text": Text, MainButton },

  data() {
    return {
      newPassword: "",
      passwordRepeat: "",
      oldPassword: "",
      errors: {},
      loading: false,
      requiredFields: ["newPassword", "passwordRepeat", "oldPassword"],
    };
  },

  methods: {
    changePassword() {
      this.errors = {};

      this.requiredFields.forEach((input) => {
        if (!this[input]) {
          this.errors[input] = "необходимо заполнить поле";
        }
      });

      if (this.newPassword !== this.passwordRepeat) {
        this.errors["newPassword"] = "Введенные пароли не совпадают";
        this.errors["passwordRepeat"] = "Введенные пароли не совпадают";
      }

      if (this.newPassword.length < 8) {
        this.errors["newPassword"] = "Пароль должен содержать мин. 8 символов";
      }

      if (Object.keys(this.errors).length) {
        return;
      }

      this.$http
        .get("user/change-password", {
          params: {
            old_password: this.oldPassword,
            new_password: this.newPassword,
          },
        })
        .then(() => {
          this.$refs.resetPassword.reset();
        })
        .catch((err) => {
          if (err.response.data) {
            this.errors = {
              ...this.errors,
              oldPassword: err.response.data,
            };
          }
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.change-password-form {
  margin-top: 32px;
}
.change-password-input {
  max-width: 600px;
}
.change-password-button {
  margin-top: 32px;
}
.change-password-info {
  margin-top: -12px;
  margin-bottom: 16px;
}
</style>
